export enum PositionType {
    TestAnalyst = 1,
    Developer = 2,
    ProjectManager = 3,
    WebDesign = 4,
    InfrastructureAnalyst = 5,
    SupportAnalyst = 6,
    ScrumMaster = 7,
    SeniorDBAAnalyst = 8,
    DBAJunior = 9,
    BDAdministrator = 10,
    NetworkAnalyst = 11,
    BusinessAnalyst = 12,
    TechnicalLeader = 13,
    BIAnalyst = 14,
    FraudManager = 15,
    RelationshipManager = 16,
    RequirementsAnalyst = 17,
    SystemsArchitect = 18,
    FunctionalAnalyst = 19,
    GovernmentAnalyst = 20,
    FullAlmAnalyst = 21,
    PRODUCTOWNER = 22,
    SystemAnalyst = 23,
    ProductionAnalyst = 24,
    SystemConfigurationManager = 25,
    InfrastructureLeader = 26,
    FullDataAnalyst = 27,
    UXExpert = 28,
    BDAnalyst = 29,
    QualityAnalyst = 30,
    InsideSales = 31,
    AzureConsultant = 32,
    Commercial = 33,
    AgileCoachSenior = 34,
    Head = 35,
    LeaderMarketing = 36,
    DevOps = 37,
    LeaderQA = 38,
    SecurityInformation = 39,
    DataScientist = 40,
    SEOAnalyst = 41,
    CybersecurityCoordinator = 42,
    SalesforceDeveloper = 43,
    InnovationSpecialist = 44,
    AccountExecutive = 45,
    CopyWritingManager = 46,
    ChiefCommercialOffice = 47,
    HeadOfPerformance = 48,
    CustomerSuccess = 49,
    CrmAnalyst = 50,
    HeadOfProjectsAndEvolution = 51,
    MarketingIntern = 52,
    DesignIntern = 53,
    DesignExpert = 54,
    SeniorAccountExecutive = 55,
    MidContentAnalyst = 56,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/PositionType.ts